import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import NestedCheckbox from '@/components/v3/NestedCheckbox.vue';
/**
 * Category Picker
 * @author Jan Canicon <jan@gorated.ph>
 *                     <jancanicon.work@gmail.com>
 * @since Version {2.21.0}
 *
 * Docs: https://gorated.atlassian.net/wiki/spaces/DMDS/pages/1856143600/Category+Picker
 */
let CategoryPicker = class CategoryPicker extends Mixins(ViewportSizeMixin) {
    get segmentedPrimaryCategories() {
        const categories = Object.keys(this.options);
        const { length } = Object.keys(this.options);
        let segment = length;
        if (this.lgAndUp) {
            segment = Math.ceil(length / this.lgCols);
        }
        else if (this.mdOnly) {
            segment = Math.ceil(length / this.mdCols);
        }
        else if (this.smOnly) {
            segment = Math.ceil(length / this.smCols);
        }
        else {
            segment = Math.ceil(length / this.xsCols);
        }
        const arr = [];
        for (let i = 0; i < length; i += segment) {
            if (i + segment < length) {
                arr.push(categories.slice(i, i + segment));
            }
            else {
                arr.push(categories.slice(i, categories.length));
            }
        }
        return arr;
    }
    get isInvalid() {
        return this.invalid && (!this.diy || this.dirty);
    }
    get selectedPrimaryCategories() {
        return Object.keys(this.value).filter((key) => this.value[key].primaryOption);
    }
    get primaryCategoryCount() {
        return this.selectedPrimaryCategories.length;
    }
    get secondaryCategoryCount() {
        return this.selectedPrimaryCategories
            .map((key) => {
            return this.value[key].secondaryOptions;
        })
            .flat().length;
    }
    secondaryCategories(category) {
        return this.options[category];
    }
};
__decorate([
    Prop({ type: Object, default: null })
], CategoryPicker.prototype, "value", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], CategoryPicker.prototype, "invalid", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], CategoryPicker.prototype, "dirty", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], CategoryPicker.prototype, "diy", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], CategoryPicker.prototype, "noTitle", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], CategoryPicker.prototype, "options", void 0);
__decorate([
    Prop({ type: String, default: 'Merchant Category' })
], CategoryPicker.prototype, "title", void 0);
__decorate([
    Prop({ type: Boolean, default: null })
], CategoryPicker.prototype, "disabled", void 0);
__decorate([
    Prop({ type: Number, default: 1 })
], CategoryPicker.prototype, "xsCols", void 0);
__decorate([
    Prop({ type: Number, default: 1 })
], CategoryPicker.prototype, "smCols", void 0);
__decorate([
    Prop({ type: Number, default: 2 })
], CategoryPicker.prototype, "mdCols", void 0);
__decorate([
    Prop({ type: Number, default: 2 })
], CategoryPicker.prototype, "lgCols", void 0);
CategoryPicker = __decorate([
    Component({
        components: {
            NestedCheckbox,
        },
    })
], CategoryPicker);
export default CategoryPicker;
